import React, { useState, useMemo } from 'react';
import { createPortal } from 'react-dom';
// import ClickOutHandler from 'react-onclickout';
import Datetime from 'react-datetime';
import classnames from 'classnames';
import moment from 'moment';
import 'moment/locale/lv';

import Icon from 'components/Icon';

const TestDate = ({ end, time, name, value, onChange }) => {
	// Handle datetime value change
	// @date: object | momentjs instance
	const handleChange = date => {
		handleModal();
		onChange({
			name,
			value: end ? date.endOf('day').format('YYYY-MM-DDTHH:mm:ss.sssZ')
				: time ? date.startOf('minute').format('YYYY-MM-DDTHH:mm:ss.sssZ')
					: date.startOf('day').format('YYYY-MM-DDTHH:mm:ss.sssZ')
		});
	};

	// Size calculation
	const size = useMemo(() => {
		if (value && time ) {
			return moment(value).format('D. MMM, YYYY HH:mm');
		} else if (value) {
			return moment(value).format('D. MMM, YYYY');
		} else {
			return 'izvēlēties';
		}
	}, [value, time]);

	// Store modal's state
	const [modal, setModal] = useState(false);

	// Toggle modal's state
	const handleModal = () => setModal(m => !m);

	return (
		<div className="datepicker">
			{/* Datepicker's icon */}
			<Icon
				size="sm"
				icon={end ? 'event' : 'today'}
				className="datepicker__icon"
			/>

			{/* Datepicker's value */}
			<div className="datepicker__value" onClick={handleModal}>{size}</div>

			{/* Datepicker's modal */}
			<Modal
				time={time}
				value={value}
				onChange={handleChange}
				modal={modal}
				handleModal={handleModal}
			/>
		</div>
	);
};

const Modal = ({ time, value, onChange, modal, handleModal }) => {
	// Custom day renderer
	const renderDay = (props, current) => {
		// Check if weekend
		const cls = classnames(props.className, {
			rdtWeekend: current.day() === 0 || current.day() === 6
		});

		return (
			<td
				{...props}
				className={cls}
			>
				<div className="rdtSize"></div>
				<div className="rdtDate">{current.date()}</div>
			</td>
		);
	};

	// Custom month renderer
	const renderMonth = (props, month) => {
		const months = moment.localeData().monthsShort();
	
		return (
			<td {...props}>
				<div className="rdtSize"></div>
				<div className="rdtDate">{months[month]}</div>
			</td>
		);
	};

	// Custom year renderer
	const renderYear = (props, year) => {
		return (
			<td {...props}>
				<div className="rdtSize"></div>
				<div className="rdtDate">{year}</div>
			</td>
		);
	};

	// Do not create portal if modal is not visible
	if (!modal) return null;

	return createPortal(
		<div className="datepickerMask">
			{/* <ClickOutHandler onClickOut={handleModal}> */}
			<Datetime
				input={false}
				locale="lv"
				dateFormat="D. MMM, YYYY"
				timeFormat={time ? 'HH:mm' : false}
				value={value ? moment(value) : null}
				closeOnSelect={true}
				onChange={onChange}
				renderDay={renderDay}
				renderMonth={renderMonth}
				renderYear={renderYear}
			/>
			{/* </ClickOutHandler> */}
		</div>
		, document.body);
};

export default TestDate;